"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = exports.bindings = exports.SimpleEvent = exports.log = exports.TaggedLog = exports.DefaultLog = exports.LogLevel = exports.legacySalvoLiteLog = exports.registerLegacySalvoLiteComponent = exports.componentService = exports.registerComponents = exports.Watch = exports.Observable = exports.Ref = exports.Prop = exports.Component = exports.useProp = exports.BaseReactComponent = exports.BaseComponent = void 0;
// Core structure
__exportStar(require("./theme"), exports);
// Components
var components_1 = require("./components");
Object.defineProperty(exports, "BaseComponent", { enumerable: true, get: function () { return components_1.BaseComponent; } });
Object.defineProperty(exports, "BaseReactComponent", { enumerable: true, get: function () { return components_1.BaseReactComponent; } });
Object.defineProperty(exports, "useProp", { enumerable: true, get: function () { return components_1.useProp; } });
Object.defineProperty(exports, "Component", { enumerable: true, get: function () { return components_1.Component; } });
Object.defineProperty(exports, "Prop", { enumerable: true, get: function () { return components_1.Prop; } });
Object.defineProperty(exports, "Ref", { enumerable: true, get: function () { return components_1.Ref; } });
Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return components_1.Observable; } });
Object.defineProperty(exports, "Watch", { enumerable: true, get: function () { return components_1.Watch; } });
Object.defineProperty(exports, "registerComponents", { enumerable: true, get: function () { return components_1.registerComponents; } });
Object.defineProperty(exports, "componentService", { enumerable: true, get: function () { return components_1.componentService; } });
Object.defineProperty(exports, "registerLegacySalvoLiteComponent", { enumerable: true, get: function () { return components_1.registerLegacySalvoLiteComponent; } });
Object.defineProperty(exports, "legacySalvoLiteLog", { enumerable: true, get: function () { return components_1.legacySalvoLiteLog; } });
// Logging
var logging_1 = require("./utils/logging");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return logging_1.LogLevel; } });
Object.defineProperty(exports, "DefaultLog", { enumerable: true, get: function () { return logging_1.DefaultLog; } });
Object.defineProperty(exports, "TaggedLog", { enumerable: true, get: function () { return logging_1.TaggedLog; } });
exports.log = new logging_1.DefaultLog();
exports.log.setLogPrefix('Theme');
exports.log.setLogLevel((process.env.NODE_ENV == 'production') ? logging_1.LogLevel.INFO : logging_1.LogLevel.DEBUG);
// Other utils
__exportStar(require("./utils"), exports);
// Events
var events_1 = require("./utils/events");
Object.defineProperty(exports, "SimpleEvent", { enumerable: true, get: function () { return events_1.SimpleEvent; } });
var bindings_1 = require("./config/bindings");
Object.defineProperty(exports, "bindings", { enumerable: true, get: function () { return bindings_1.bindings; } });
// Initialization
var main_1 = require("./theme/main");
Object.defineProperty(exports, "main", { enumerable: true, get: function () { return main_1.main; } });
//# sourceMappingURL=index.js.map